var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.0458,
    y: 3.39883,
    width: 10.386,
    height: 18.2033,
    rx: 0.65,
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77529 15.3435C9.77529 13.4324 11.3265 11.8812 13.2376 11.8812C15.1486 11.8812 16.6998 13.4324 16.6998 15.3435C16.6998 17.2546 15.1486 18.8058 13.2376 18.8058C11.3265 18.8058 9.77529 17.2546 9.77529 15.3435Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0194 15.3448C12.0194 14.6718 12.5658 14.1254 13.2388 14.1254C13.9118 14.1254 14.4582 14.6718 14.4582 15.3448C14.4582 16.0178 13.9118 16.5642 13.2388 16.5642C12.5658 16.5642 12.0194 16.0178 12.0194 15.3448Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0194 8.12994C12.0194 7.45693 12.5658 6.91055 13.2388 6.91055C13.9118 6.91055 14.4582 7.45693 14.4582 8.12994C14.4582 8.80294 13.9118 9.34933 13.2388 9.34933C12.5658 9.34933 12.0194 8.80294 12.0194 8.12994Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.d5ffea03d4d4bab8cf849dcac7d7a13c.svg";
export { ForwardRef as ReactComponent };